module.exports = __webpack_public_path__ + "e727aa48315224f94b53664319a70e09.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/tiers/wing-8.png
// module id = 3478
// module chunks = 0